import { render } from "./BaseUpload.vue?vue&type=template&id=b6d65a7c&scoped=true&lang=pug"
import script from "./BaseUpload.vue?vue&type=script&lang=js"
export * from "./BaseUpload.vue?vue&type=script&lang=js"

import "./BaseUpload.vue?vue&type=style&index=0&id=b6d65a7c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d65a7c"]])

export default __exports__